import { isMobile } from 'utils/is-mobile';

export const applyDeviceTypeAttributeToDocument = () => {
  const deviceTypeAttribute = isMobile() ? 'mobile' : 'desktop';
  document.documentElement.setAttribute(
    'data-device-type',
    deviceTypeAttribute
  );
};
